const global = global || window;

class Maps {

	constructor() {
		this.isReady = false;
		this.listeners = [];
	}

	ready(callback) {
		if (this.isReady) {
			callback(global.google);
			return this;
		}

		this.listeners.push(callback);
		return this;
	}

	get initializer() {
		return () => {
			if (!this.isReady) {
				this.isReady = true;
				this.listeners.forEach(callback => callback(global.google));
			}
		};
	}

}

module.exports = new Maps();


// WEBPACK FOOTER //
// ./resources/js/services/maps.js